<div class="c-slat__content c-vacatures-widget__slat">
  <div class="c-vacatures-widget__slat-title">
    <div class="c-vacatures-widget__slat-status has-loading__box -h-body -w30 u-mb05"></div>
    <div class="u-mt0 u-mb0 has-loading__box -h-h3 -w60"></div>
  </div>
  <ul class="u-reset-list c-vacatures-widget__vacstats">
    <li class="c-vacatures-widget__stat-container">
      <div class="c-vacatures-widget__stat-number has-loading__box -h-3 -w50"></div>
      <div class="c-vacatures-widget__stat-label has-loading__box -h-body -w50"></div>
    </li>
    <li class="c-vacatures-widget__stat-container">
      <div class="c-vacatures-widget__stat-number has-loading__box -h-3 -w50"></div>
      <div class="c-vacatures-widget__stat-label has-loading__box -h-body -w50"></div>
    </li>
  </ul>
</div>
